import usePrivateAxios from "@/common/api/usePrivateAxios";
import { useMutation } from "@tanstack/react-query";
import { AxiosError, AxiosResponse } from "axios";

interface UseDisableMissionProps {
  onSuccess?: (response: AxiosResponse) => void;
  onError?: (error: AxiosError) => void;
}

interface DisableMissionVariables {
  id: string;
  reason: string;
}

export const useDisableMission = ({
  onSuccess,
  onError,
}: UseDisableMissionProps = {}) => {
  const privateAxios = usePrivateAxios();

  return useMutation({
    mutationKey: ["disableMission"],
    mutationFn: async ({ id, reason }: DisableMissionVariables) =>
      privateAxios.put(`/tmais/missions/${id}/disable`, {
        mission: {
          status: "inactive",
          disable_reason: reason.trim(),
        },
      }),
    onSuccess,
    onError,
  });
};
